import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import JSshare from "./JSshare";
import styles from "../RequestForQuotePage/index.module.css";
import WishlistImages from "./WishlistImages";
// import { LoadingOverlay, Loader } from "react-overlay-loader";
import "../../black-box/custom.css";
import { IoArrowBack } from "react-icons/io5";


const GetSavedLater = () => {
    const [selectedCheckbox, setselectedCheckbox] = useState({});
    const [getWishlistproduct, setWishlistProduct] = useState([]);
    const [getWishlist, setWishlist] = useState([]);
    const [cookies, setCookie, removeCookie] = useCookies("gemfind_sessionId");
    const [loaded, setLoaded] = useState(false);
    const [loadApi, setloadApi] = useState(true);
    const [callremove, setCallRemove] = useState(false);
    const [checked, setchecked] = useState(false);
    const [getImage, setImage] = useState([]);
    const [sortOrder, setsortOrder] = useState('asc');

    const getQuotedProductCount = async () => {
        setLoaded(true);
        const requestOptions = {
            method: "POST",

            // mode: "no-cors",
            // headers: {
            //     'Content-Type': 'application/json'
            // },

            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                product_id: "",
                saveforlater: "true",
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "myWishlist",
            requestOptions
        );
        const set_count = await res.json();
        // console.log(set_count);
        var wishlist_status_pro = set_count.data.wishlist_status;
        var wishlists = set_count.data.wishlists;
        var images = {};
        Object.keys(wishlists).map(key => {
            var arr = [];
            var i = 0;
            wishlist_status_pro.map(item => {
                if (item.wishlist_id == wishlists[key]) {
                    arr[i] = item.image;
                    i++;
                }
            })
            images[key] = arr;
            // console.log(images)
        })
        var data = set_count.data.wishlist_status;
        data.sort(function (a, b) {
            return parseFloat(a.price) - parseFloat(b.price);
        });
        setImage(images);
        setWishlist(set_count.data.wishlists);
        setWishlistProduct(data);

        setLoaded(false);
        setloadApi(false);
    };
    useEffect(() => {
        if (loadApi === true) {
            getQuotedProductCount();
        }
    }, [loadApi, getWishlist, getWishlistproduct]);


    const handleRemoveClick = async (id, quantity, var_id) => {
        setCallRemove(true);
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                session_id: cookies.gemfind_sessionId,
                product_id: id,
                saveforlater: "true",
                customer_id:
                    window.meta.page.customerId != undefined
                        ? window.meta.page.customerId
                        : null
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "removeWishlist",
            requestOptions
        );
        let formData = {
            'items': [{
                'id': var_id,
                'quantity': quantity
            }]
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                window.location.href = '/cart';
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        // getQuotedProductCount();

    };

    useEffect(() => {
        const selected = selectedCheckbox;
        setselectedCheckbox(selected);
    }, [selectedCheckbox, checked]);

    function multipleInputSelection(e) {
        setchecked(!checked);

        if (selectedCheckbox[e.target.value]) {
            delete selectedCheckbox[e.target.value];
        } else {
            selectedCheckbox[e.target.value] = e.target.getAttribute('data-quan');
        }
    }
    function multipleaddtocart() {
        let formData = {
            'items': []
        };

        Object.keys(selectedCheckbox).map(key => {
            var arr = {};
            arr['id'] = key;
            arr['quantity'] = selectedCheckbox[key];
            formData.items.push(arr);

            const matchingItem = getWishlistproduct.find(item => item.var_id === key);
            console.log(matchingItem)
            const requestOptions = {
                method: "POST",
                body: JSON.stringify({
                    shop_domain: window.Shopify.shop,
                    session_id: cookies.gemfind_sessionId,
                    product_id: matchingItem.id,
                    saveforlater: "true",
                    customer_id:
                        window.meta.page.customerId != undefined
                            ? window.meta.page.customerId
                            : null
                })
            };
            const res = fetch(
                `${process.env.REACT_APP_API_URL}` + "removeWishlist",
                requestOptions
            );

        });

        // console.log(formData)
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
            .then(response => {
                window.location.href = '/cart';
            })
            .catch((error) => {
                console.error('Error:', error);
            });


    }

    useEffect(() => {
        const sortedProducts = [...getWishlistproduct];

        if (sortOrder === 'asc') {
            sortedProducts.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
        } else {
            sortedProducts.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
        }

        setWishlistProduct(sortedProducts);
    }, [sortOrder])

    function sortOrderFunc(e) {
        setsortOrder(e.target.value);
    }

    // console.log(getWishlistproduct);
    const setEqualHeight = () => {
        const elements = document.querySelectorAll('.same-height');
        let maxHeight = 0;

        elements.forEach((el) => {
            el.style.height = 'auto'; // Reset height
            const height = el.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        elements.forEach((el) => {
            el.style.height = `${maxHeight}px`;
        });
    };

    setEqualHeight();
    window.addEventListener('resize', setEqualHeight);

    useEffect(()=>{
        if(loaded){
            document.querySelector(".gf--loader--body").style="display:block;";
        }else{
            document.querySelector(".gf--loader--body").style="display:none;";
        }
    },[loaded]);



    const content1 = (
        <>
            {getWishlist['U0ZM'] ? (
                <>
                    {/* <LoadingOverlay className="_loading_overlay_wrapper">
                        <Loader fullPage loading={loaded} />
                    </LoadingOverlay> */}
                    <div className={styles.gemgridrow}>
                        <div className={"gf--tab--header"}>
                            <div className={"gf--header-addbtn "}>
                                <h2 >Saved for Later</h2>
                                <div className="gf--products-sort-div">
                                    <select onChange={(e) => sortOrderFunc(e)} className={"gf-back--btn "}>
                                        <option value="asc">Price – low to high</option>
                                        <option value="desc">Price – high to low</option>
                                    </select>
                                </div>

                            </div>


                            {/* <div className="gf--products-sort-div">
                                <h2>{currentTab}</h2>
                                <select onChange={(e) => sortOrderFunc(e)} className={"gf-back--btn " + `${currentTab != '' ? '' : 'gf--steps-back-btn-hide'}`}>
                                    <option value="asc">Price – low to high</option>
                                    <option value="desc">Price – high to low</option>
                                </select>
                            </div> */}
                        </div>
                        <div className="gf--add-compare-btns gf--header-addbtn">
                            <button onClick={multipleaddtocart} className={"gf--add-to-cart-btn " + `${Object.keys(selectedCheckbox).length == 0 ? 'gf--steps-back-btn-hide' : ''}`} >Move to cart<span>{Object.keys(selectedCheckbox).length}</span></button>

                            {/* <button onClick={compareProducts} className={"gf--add-to-cart-btn " + `${Object.keys(selectedCheckbox).length == 0 ? 'gf--steps-back-btn-hide' : ''}`} >Compare Products<span>{Object.keys(selectedCheckbox).length}</span></button> */}
                        </div>



                        <div className={styles.gridcontainer}>
                            {Object.keys(getWishlist).map(key =>
                                key === 'U0ZM' ?
                                    <>
                                        <div className={"gf--steps-content"}>
                                            {getWishlistproduct.map(item => (
                                                getWishlist[key] == item.wishlist_id ?
                                                    <div className={styles.gridboxChild}>
                                                        <div className="gf-wishlist-pro-quantity">{"Quantity: " + item.quantity}</div>

                                                        <input onChange={(e) => multipleInputSelection(e)} data-quan={item.quantity} className="gf--input-selection" type="checkbox" value={item.var_id} checked={selectedCheckbox[item.var_id]} />

                                                        <div className={styles.productimg}>
                                                            <img src={item.image} alt="watch" />
                                                        </div>
                                                        <div className={styles.productinfo}>
                                                            <h2 className={'same-height '+styles.Product_title}>
                                                                {item.title}
                                                            </h2>
                                                            <h3 className={styles.Product_price}>
                                                                ${item.price}
                                                            </h3>
                                                            {item.stock_status != "In Stock" ? (
                                                                <span
                                                                    className={
                                                                        styles.Productstock +
                                                                        " " +
                                                                        styles.outofstock
                                                                    }
                                                                >
                                                                    out of stock
                                                                </span>
                                                            ) : (
                                                                <span
                                                                    className={
                                                                        styles.Productstock +
                                                                        " " +
                                                                        styles.instock
                                                                    }
                                                                >
                                                                    instock
                                                                </span>
                                                            )}
                                                            <p className="gr98423">&nbsp;</p>
                                                            <div onClick={() => handleRemoveClick(item.id, item.quantity, item.var_id)} className="gf-remove-btn">
                                                                Move To Cart
                                                            </div>
                                                            {/* <button onClick={()=>handleRemoveClick(item.id)} className="gf-remove-btn">Remove</button> */}
                                                        </div>
                                                    </div>
                                                    : ''))}
                                        </div>
                                    </>
                                    : '')}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <style>
                        {`
                    .react-overlay-loader-spinner {
                        background-image: url(${process.env.REACT_APP_IMAGE_URL}"images/heart_loader.gif");
                    }
                `}
                    </style>
                    {/* <LoadingOverlay className="_loading_overlay_wrapper">
                        <Loader fullPage loading={loaded} />
                    </LoadingOverlay> */}

                    <div className={styles.gemgridrow}>
                        <div className="gf-no-sfl">
                            No products are currently saved
                            <p>Save some products for later from the cart page</p>
                            <a href={"/cart"}>Open Cart Page</a>
                        </div>
                    </div>
                </>
            )}
        </>
    );

    return (
        <div>{content1}</div>
    );

}

export default GetSavedLater;